var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-col",
    { staticClass: "ma-0 pa-5", attrs: { cols: "12" } },
    [
      _c(
        "v-row",
        { staticClass: "ma-0 pa-0 mb-3", attrs: { justify: "end" } },
        [
          _c(
            "v-btn",
            {
              attrs: { id: "transparent_btn", elevation: "0" },
              on: { click: _vm.openCameraSearch },
            },
            [
              _c("v-img", {
                attrs: {
                  id: "cctv_icon",
                  src: require("@/assets/images/cctv_plus.png"),
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.streamingUrlLoading == false
        ? [
            _vm.cameraList.length > 0
              ? _c(
                  "v-row",
                  { staticClass: "ma-0 pa-0" },
                  _vm._l(_vm.cameraList, function (item, index) {
                    return _c(
                      "v-col",
                      {
                        key: index,
                        staticClass: "ma-0 pa-2",
                        attrs: { cols: "3" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "cg_thumb",
                            staticStyle: { cursor: "pointer" },
                            on: {
                              click: function ($event) {
                                return _vm.goVideoPlayer(item)
                              },
                            },
                          },
                          [
                            item.offline
                              ? [
                                  _c("div", { staticClass: "cg_offline" }, [
                                    _vm._v(_vm._s(_vm.t("offline"))),
                                  ]),
                                ]
                              : [
                                  item.thumbnailSrc &&
                                  _vm.imageError[index] === false
                                    ? _c("img", {
                                        staticClass: "cg_img",
                                        attrs: { src: item.thumbnailSrc },
                                        on: {
                                          error: function ($event) {
                                            return _vm.thumbnailError(
                                              index,
                                              $event
                                            )
                                          },
                                        },
                                      })
                                    : _vm.imageError[index]
                                    ? _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          staticStyle: {
                                            "background-color":
                                              "rgb(69, 69, 69)",
                                            height: "100%",
                                            "align-content": "center",
                                          },
                                        },
                                        [
                                          _c("div", [
                                            _vm._v("サムネイル・エラー"),
                                          ]),
                                        ]
                                      )
                                    : _c("v-skeleton-loader", {
                                        staticClass: "cg_img_skeleton",
                                        attrs: {
                                          type: "image",
                                          dark: "",
                                          boilerplate: false,
                                          elevation: "0",
                                        },
                                      }),
                                ],
                            _c("div", { staticClass: "cg_name ellipsis" }, [
                              _vm._v(_vm._s(item.cameraName)),
                            ]),
                          ],
                          2
                        ),
                      ]
                    )
                  }),
                  1
                )
              : _c(
                  "v-col",
                  {
                    staticClass: "ma-0 pa-10",
                    attrs: { cols: "12", align: "center", id: "cg_nodata" },
                  },
                  [_vm._v(" " + _vm._s(_vm.t("noData")) + " ")]
                ),
          ]
        : [
            _c(
              "v-col",
              {
                staticClass: "ma-0 pa-10",
                attrs: { cols: "12", align: "center" },
              },
              [
                _c("v-progress-circular", {
                  attrs: {
                    indeterminate: "",
                    color: "white",
                    width: 4,
                    size: 30,
                  },
                }),
              ],
              1
            ),
          ],
      _c("CameraGroupAddDialog", {
        attrs: { dialogVisible: _vm.cameraSearchDialogVisible },
        on: {
          visible: _vm.cameraSearchDialogVisibleFunc,
          add: _vm.addSelectedCamerasFunc,
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }